<template>
    <section class="c-register">
        <div class="c-register__body">

            <template v-if="!formIsSent">

                <app-intro class="u-d-flex justify-content-center">
                    <h1>Registreren</h1>
                </app-intro>

                <register-form v-on:formIsSent="formIsSent = $event" theme="light"/>
            </template>

            <template v-else>
                <app-intro>
                    <h2>Je account is aangemaakt</h2>
                    <p>Er is een activatie-mail aan je verzonden. In sommige gevallen kan het, afhankelijk van je e-mail provider, tot 10 minuten duren voordat je de activatie e-mail hebt ontvangen. Ontvang je geen activatie-mail neem contact op via onze supportpagina.</p>
                </app-intro>
            </template>

        </div>
    </section>
</template>

<script>
    import AppIntro from '../../components/app/AppIntro.vue';
    import RegisterForm from '../../components/forms/RegisterForm.vue';

    export default {
        components: { RegisterForm, AppIntro },
        data () {
            return {
                formIsSent: false,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-register {
        display: grid;
        height: 100%;

        &__body {
            align-self: center;
            justify-self: center;
            padding: 0 grid(1);

            @include media-breakpoint-up(md) {
                margin: 0 auto;
                padding: 0;
                width: grid(12, lg);
            }
        }
    }
</style>
